import styled from "styled-components";

export const Styles = styled.div`
  .back-to-top {
    position: fixed;
    right: 28px;
    bottom: 28px;
    z-index: 1000;
    display: flex;
    width: 48px;
    height: 48px;
    align-items: center;
    justify-content: center;
    border: 1px solid #1a1a1c;
    border-radius: 50%;
    background: #1a1a1c;
    color: #ffffff;
    box-shadow: 0 8px 24px rgba(26, 26, 28, 0.24);
    cursor: pointer;
    opacity: 0;
    pointer-events: none;
    transform: translateY(14px);
    transition: opacity 180ms ease, transform 180ms ease, background 180ms ease, color 180ms ease;

    &.visible {
      opacity: 1;
      pointer-events: auto;
      transform: translateY(0);
    }

    &:hover,
    &:focus-visible {
      background: #ffffff;
      color: #1a1a1c;
    }

    &:focus-visible {
      outline: 3px solid rgba(47, 112, 181, 0.35);
      outline-offset: 3px;
    }

    svg {
      font-size: 30px;
    }
  }

  @media screen and (max-width: 600px) {
    .back-to-top {
      right: 18px;
      bottom: 18px;
      width: 44px;
      height: 44px;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .back-to-top {
      transition: none;
    }
  }
`;
